<template>
  <div name="modal" v-if="showModal">
    <div class="modal-mask" @click.self="clickMask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <slot name="header">
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
            </slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

/** \brief  Basic component to use to general modal windows. 
  * The component proposes multiple slots: modal-header, modal-body, and modal-footer */
export default {
  props: {
  /** \brief  Should the modal window be displayed? */
    showModal: { type: Boolean },
  },
  methods: {
    /** \brief Function called when the user clicks outside the modal window (in the "mask") 
    * \param event the mouse click event */
    clickMask(event) {
      this.$emit('clickMask', event);
    }
  },
};

</script>

<style>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s ease;
  display: flex;
}

.modal-wrapper {
  margin: auto;
}

.modal-container {
  width: 500px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-footer {
  display: initial;
}

</style>
